import React, {
  useEffect,
  useState,
  createContext,
  PropsWithChildren,
  useContext,
} from "react";
import {
  Keyboard,
  KeyboardEventListener,
  KeyboardMetrics,
  Platform,
  useWindowDimensions,
} from "react-native";
import Constants from "expo-constants";

const emptyCoordinates = {
  screenX: 0,
  screenY: 0,
  width: 0,
  height: 0,
};
const initialValue = {
  end: emptyCoordinates,
};

const Context = createContext({
  keyboardShown: false,
  coordinates: initialValue,
  keyboardHeight: 0,
  availableRect: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
});

export const useKeyboard = () => {
  const context = useContext(Context);
  return context;
};
export function KeyboardProvider(props: PropsWithChildren<any>) {
  const [shown, setShown] = useState(false);

  const [coordinates, setCoordinates] = useState<{
    end: KeyboardMetrics;
  }>(initialValue);
  const [keyboardHeight, setKeyboardHeight] = useState<number>(0);
  useWindowDimensions();
  const handleKeyboardWillShow: KeyboardEventListener = (e) => {
    setShown(true);
    setCoordinates({ end: e.endCoordinates });
    setKeyboardHeight(e.endCoordinates.height);
  };

  const handleKeyboardWillHide: KeyboardEventListener = (e) => {
    setShown(false);
    if (e) {
      setCoordinates({ end: e.endCoordinates });
    } else {
      setCoordinates(initialValue);
      setKeyboardHeight(0);
    }
  };

  useEffect(() => {
    const willShowListener = Keyboard.addListener(
      "keyboardWillShow",
      handleKeyboardWillShow
    );
    const didShowListener = Keyboard.addListener(
      "keyboardDidShow",
      handleKeyboardWillShow
    );
    const willHideListener = Keyboard.addListener(
      "keyboardWillHide",
      handleKeyboardWillHide
    );
    const didHideListener = Keyboard.addListener(
      "keyboardDidHide",
      handleKeyboardWillHide
    );
    return () => {
      willShowListener.remove();
      didShowListener.remove();
      willHideListener.remove();
      didHideListener.remove();
    };
  }, []);

  return (
    <Context.Provider
      value={{
        keyboardShown: shown,
        coordinates,
        keyboardHeight,
        availableRect: {
          top: Constants.statusBarHeight,
          left: 0,
          right: 0,
          bottom:
            shown && (Platform.OS === "ios" || Platform.OS === "android")
              ? keyboardHeight
              : 0,
        },
      }}
    >
      {props.children}
    </Context.Provider>
  );
}
